module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6ApZ4"))).then(() => module.bundle.root('6TueN'));